<script lang="ts">
  import Label from "$lib/components/ui/label/label.svelte";
  import { t } from "svelte-i18n";
  import * as Carousel from "$lib/components/ui/carousel/index.js";
  import { Mail, Phone } from "lucide-svelte";
  import EditContactDialog from "./edit-contact-dialog.svelte";
  import { type Customer } from "$src/domain/customers/Customer";
  import { type Contact } from "$src/domain/customers/Contact";
  import {
    projectDraft,
    projectOriginal,
  } from "$src/application/projects/stores/projectStore";
  import { isEditActive } from "$src/application/main/mainTemplateStore";

  export let isEditMode: boolean = false;
  export let patchHandler: () => void;

  $: customer =
    $isEditActive && $projectDraft
      ? $projectDraft.customer
      : $projectOriginal.customer;

  function addContact(e: CustomEvent<Contact>) {
    $projectDraft.customer.contacts.push(e.detail);

    $projectDraft.customer = { ...$projectDraft.customer };
    patchHandler();
  }

  function updateContact(e: CustomEvent<Contact>) {
    $projectDraft.customer = { ...$projectDraft.customer };
    patchHandler();
  }

  function deleteContact(e: CustomEvent<Contact>) {
    $projectDraft.customer.contacts = $projectDraft.customer.contacts.filter(
      (contact) => contact !== e.detail
    );

    $projectDraft.customer = { ...$projectDraft.customer };
    patchHandler();
  }
</script>

<div class="flex items-center gap-2 p-2">
  <Label class="text-muted-foreground text-xs">
    {$t("page.customers.labels.contacts")}
  </Label>

  {#if isEditMode}
    <EditContactDialog on:contactCreated={addContact} />
  {/if}
</div>
<Carousel.Root class="pb-8">
  <Carousel.Content class="text-xs gap-2 ml-0 ">
    {#each customer.contacts as contact}
      <Carousel.Item
        class="relative basis-4/5 border p-2 rounded-lg bg-card h-24 cursor-pointer"
      >
        <div class="font-semibold pb-2">
          {contact.lastname}
          {contact.firstname}
        </div>
        {#if contact.email}
          <div class="flex flex-row gap-2 items-center h-8">
            <Mail class="w-4 h-4 flex-shrink-0" />
            <a
              href="mailto:pierre.ioannatos@louiseverlaine.com"
              class="hover:text-secondary-foreground break-all"
            >
              {contact.email}
            </a>
          </div>
        {/if}
        <div class="flex flex-row gap-2 items-center">
          <Phone class="w-4" />
          <div>{contact.phoneNumber1}</div>
          {#if isEditMode}
            <EditContactDialog
              editMode={true}
              {contact}
              on:contactUpdated={updateContact}
              on:contactDeleted={deleteContact}
            />
          {/if}
        </div>
      </Carousel.Item>
    {/each}
  </Carousel.Content>
  {#if customer.contacts && customer.contacts.length > 1}
    <Carousel.Previous class="left-1/2 translate-y-9 -translate-x-8 h-6 w-5" />
    <Carousel.Next class="right-1/2  translate-y-9 translate-x-8  h-6 w-6" />
  {/if}
</Carousel.Root>
